import React from 'react';
import { Dropdown } from 'react-bootstrap';
import AdminListStatus from './AdminListStatus';
import DonorListGender from './DonorListGender';

function BiologicalSexDropdown({ genders, selectedGenders, handleGenderChange, setSelectedGenders }) {
 
    return (
        <Dropdown className="d-inline-block">
            <Dropdown.Toggle className="p-0" id="statusFilterDropdown">
                Biological Sex
            </Dropdown.Toggle>

            <Dropdown.Menu>
                <form>
                    {genders.map((gender) => (
                        <DonorListGender
                        label={gender.label}
                            selectedGenders={selectedGenders}
                            key={gender.id}
                            gender={gender.value}
                            id={gender.id}
                            onClick={handleGenderChange}
                        />
                    ))}
                </form>
                <div>
                    <input
                        type="button" value="Clear All"
                        className="btn btn-link"
                        onClick={() => setSelectedGenders([])}
                    />


                </div>
            </Dropdown.Menu>
        </Dropdown>
    );
}

export default BiologicalSexDropdown;
